<template>
  <div v-if="debugStore.isDebugEnabled" class="debug_toolbar">
    <h5 class="mb-5">Debug toolbar</h5>
    <div class="flex flex-col gap-2">
      <div class="flex flex-row gap-2">
        <UCheckbox v-model="debugStore.isArticlesLoading" label="Articles loading" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useDebugStore} from "~/stores/useDebugStore";
const debugStore = useDebugStore()
</script>

<style lang="scss" scoped>
.debug_toolbar {
  @apply text-gray-500 fixed bottom-16 bg-gray-200 z-50 w-auto h-auto right-5 rounded-xl p-5 border-gray-500;

  //input[type='checkbox'] {
  //  @apply h-5 w-5;
  //}
}
</style>

